import { ShortUrl } from '@air/api';
import { ClipSource } from '@air/api/types';
import { Upload } from '@air/redux-uploader';

import { reportErrorToBugsnag } from '~/utils/ErrorUtils';

interface GetSmallPublicUploadUrlsParams {
  apiUploadData: Upload['apiUploadData'];
  shortBoardId: string;
  sessionId: string;
}

export const fetchSmallPublicUploadUrl = async ({
  sessionId,
  shortBoardId,
  apiUploadData,
}: GetSmallPublicUploadUrlsParams) => {
  try {
    const urls = await ShortUrl.getUploadUrls(shortBoardId, [apiUploadData], {
      source: ClipSource.web,
      sessionId,
    });
    return urls[0];
  } catch (error) {
    throw reportErrorToBugsnag({
      error,
      context: `Failed to get public small upload url`,
      metadata: {
        data: {
          apiUploadData,
        },
      },
    });
  }
};
